import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';

export default function EligibilitySectionCard(props) {
  const {title, children, onClickTopIcon, idSection} = props;

  return (
    <Card variant="outlined">
      <CardHeader
        action={
          <IconButton aria-label="remove" onClick={() => onClickTopIcon(idSection)}>
            <DeleteOutlinedIcon />
          </IconButton>
        }
        title={title}
      />
      <CardContent>
        <Grid container>
          {children}
        </Grid>
      </CardContent>
    </Card>
  );
}
